<template>
  <div class="my-account">
    <md-card>
      <md-card-header>
        <md-card-header-text>
          <div class="md-title">My account</div>

          <md-list class="md-double-line">
            <md-list-item>
              <md-icon class="md-primary">person</md-icon>

              <div class="md-list-item-text">
                <span>{{ user.displayName }}</span>
              </div>

              <md-tooltip md-direction="left">Name</md-tooltip>
            </md-list-item>

            <md-list-item>
              <md-icon class="md-primary">email</md-icon>

              <div class="md-list-item-text">
                <span>{{ user.email }}</span>
              </div>

              <md-tooltip md-direction="left">Email</md-tooltip>
            </md-list-item>

            <md-list-item v-if="user.roles && user.roles.length">
              <md-icon class="md-primary">admin_panel_settings</md-icon>

              <md-chip v-for="role in user.roles" :key="role">{{ role }}</md-chip>

              <div class="md-list-item-text"></div>

              <md-tooltip md-direction="left">Roles</md-tooltip>
            </md-list-item>

            <md-list-item v-if="user.analyticsAgreed !== 'undefined'">
              <md-icon class="md-primary">bar_chart</md-icon>

              <div v-if="user.analyticsAgreed" class="md-list-item-text">You are allowing analytics to be tracked <md-badge class="md-square" md-content="ON" /></div>
              <div v-else class="md-list-item-text">You are not allowing analytics to be tracked <md-badge class="md-square md-primary" md-content="OFF" /></div>

              <md-tooltip md-direction="left">Analytics</md-tooltip>
            </md-list-item>

          </md-list>
        </md-card-header-text>

        <md-card-media md-medium v-if="user.photoURL">
          <img v-bind:src="user.photoURL" alt="Photo" />
        </md-card-media>
      </md-card-header>

      <md-card-actions>
        <md-button @click="editProfile()">Update profile</md-button>
        <md-button v-if="!user.isLtiUser" @click="changeEmail()">Change email</md-button>
        <md-button v-if="!user.isLtiUser" @click="changePassword()">Change password</md-button>
      </md-card-actions>
    </md-card>

    <UserListAddEditUser ref="editProfileDialog" @user-save="onProfileEdit" :isEdit="false" :analyticsAgreement="user.analyticsAgreed" />
    <MyAccountChangeEmail ref="changeEmailDialog"  @save="onChangeEmail" />
    <MyAccountChangePassword ref="changePasswordDialog"  @save="onChangePassword" />

    <md-snackbar
      :md-position="'center'"
      :md-duration="10000"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ message }}</span>
    </md-snackbar>
  </div>
</template>

<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 * 
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 * 
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
import { AuthService } from "@/services/auth.service";
import { functions } from "../firebaseFunctions.js";
import UserListAddEditUser from "@/components/UserListAddEditUser.vue";
import MyAccountChangeEmail from "@/components/MyAccountChangeEmail.vue";
import MyAccountChangePassword from "@/components/MyAccountChangePassword.vue";

export default {
  name: "MyAccount",
  components: {
    UserListAddEditUser,
    MyAccountChangeEmail,
    MyAccountChangePassword    
  },
  data: () => ({
    user: null,
    showSnackbar: false,
    message: ""
  }),
  methods: {
    editProfile() {
      this.$refs.editProfileDialog.showDialog(this.user);
    },
    onProfileEdit(user) {
        AuthService.updateProfile(user).then(
            () => {
                this.message = `Profile was updated successfully`;
                this.showSnackbar = true;
            },
            error => {
                this.message = `Could not update profile. Error occured: '${error}'`;
                this.showSnackbar = true;
            }
        );

        functions.updateAnalytics(this.user).then( function() {
            AuthService.refreshCurrentUser(this.user);
        }.bind(this));
    },
    changeEmail() {
      this.$refs.changeEmailDialog.showDialog();
    },
    onChangeEmail(model) {      
      AuthService.updateEmail(model.currentPassword, model.newEmail).then(
        () => {
          this.message = `Email was updated successfully`;
          this.showSnackbar = true;
        },
        error => {
          this.message = `Could not update email. Error occured: '${error}'`;
          this.showSnackbar = true;
        }
      );
    },
    changePassword() {
      this.$refs.changePasswordDialog.showDialog();
    },
    onChangePassword(model) {
      AuthService.updatePassword(model.currentPassword, model.newPassword).then(
        () => {
          this.message = `Password was updated successfully`;
          this.showSnackbar = true;
        },
        error => {
          this.message = `Could not update password. Error occured: '${error}'`;
          this.showSnackbar = true;
        }
      );
    }
  },
  created() {
    this.subscription = AuthService.loggedUser$.subscribe(user => {
      this.user = user;
      this.user.isCurrentUser = true;
    });
  },
  beforeDestroy() {
    this.subscription.unsubscribe();
  }
};
</script>

<style scoped>
@media only screen and (min-width: 600px) {
  .my-account {
    padding-left: 55px;
    padding-right: 55px;
  }
}
</style>